import Vue from 'vue'
import Vuex, { mapActions, mapGetters, mapMutations } from 'vuex'

import { AttachmentModule } from '@/modules/AttachmentModule'
import { AuthorModule } from '@/modules/AuthorModule'
import { BrandingTemplateModule } from '@/modules/BrandingTemplateModule'
import { EmailModule } from '@/modules/EmailModule'
import { LoaderModule } from '@/modules/LoaderModule'
import { NewsletterModule } from '@/modules/NewsletterModule'
import { NewsletterTypeModule } from '@/modules/NewsletterTypeModule'
import { ProviderModule } from '@/modules/ProviderModule'
import { PurchaseModule } from '@/modules/PurchaseModule'
import { PurchasableItemModule } from '@/modules/PurchasableItemModule'
import { PuzzleModule } from '@/modules/PuzzleModule'
import { SettingModule } from '@/modules/SettingModule'
import { StatModule } from '@/modules/StatModule'
import { SubscriptionModule } from '@/modules/SubscriptionModule'
import { UserDetailModule } from '@/modules/UserDetailModule'
import { UserModule } from '@/modules/UserModule'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    base: {
      loading: false
    },
    packageVersion: process.env.PACKAGE_VERSION || '0'
  },

  getters: {
    appVersion: (state) => {
      return state.packageVersion
    }
  },

  modules: {
    AuthorModule,
    AttachmentModule,
    BrandingTemplateModule,
    EmailModule,
    LoaderModule,
    NewsletterModule,
    NewsletterTypeModule,
    ProviderModule,
    PurchaseModule,
    PurchasableItemModule,
    PuzzleModule,
    SettingModule,
    StatModule,
    SubscriptionModule,
    UserModule,
    UserDetailModule
  },

  methods: {
    // AttachmentModule
    ...mapActions('AttachmentModule', [
      'getAttachment'
    ]),

    ...mapMutations('AttachmentModule', [
      'storeAttachment'
    ]),

    // EmailModule
    ...mapGetters('EmailModule', [
      'isNewsletter'
    ]),

    ...mapActions('EmailModule', [
      'getAdminNewsletter',
      'getEmails',
      'getEmail',
      'getNewsletter',
      'getNewsletters',
      'getEmailRecipient',
      'publishEmail',
      'publishNewsletter'
    ]),

    ...mapActions('LoaderModule', [
      'setLoaders'
    ]),

    ...mapActions('NewsletterModule', [
      'getNewsletter',
      'getNewsletterAttachments'
    ]),

    ...mapActions('NewsletterTypeModule', [
      'getNewsletterType'
    ]),

    ...mapActions('PurchaseModule', [
      'activateProvider',
      'deactivateProvider'
    ]),

    ...mapMutations('EmailModule', [
      'storeEmail',
      'storeEmails',
      'storeRecipient'
    ]),

    ...mapMutations('NewsletterModule', [
      'storeNewsletter',
      'storeNewsletterAttachments',
      'storeNewsletters'
    ]),

    // PurchasableItemModule
    ...mapActions('PurchasableItemModule', [
      'getPurchasableItems'
    ]),

    ...mapMutations('PurchasableItemModule', [
      'storeItems'
    ]),

    // SettingModule
    ...mapActions('SettingModule', [
      'getSettings'
    ]),

    ...mapMutations('SettingModule', [
      'storeSettings'
    ]),

    // PuzzleModule
    ...mapActions('PuzzleModule', [
      'getAttachments',
      'getPuzzle',
      'getPuzzles',
      'setAttachments'
    ]),

    ...mapMutations('PuzzleModule', [
      'storePuzzleAttachments',
      'storePuzzle',
      'storePuzzles'
    ]),

    // SubscriptionModule
    ...mapActions('SubscriptionModule', [
      'getSubscription',
      'getSubscriptions'
    ]),

    ...mapMutations('SubscriptionModule', [
    ]),

    ...mapMutations('UserModule', [
      'storeUserRoleId'
    ])
  },

  mutations: {
    setLoading (state, bool, type = 'base') {
      state[type].loading = bool
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/BaseStore.js